import { createRoot } from "react-dom/client";
import App from "./App";
import "./_shared/assets/i18n/i18n";
import "./mocks";
import "@orion/themes/reset.css";
import "@orion/framework/style.css";
import "@orion/themes/reset.css";
import "@orion/ui/style.css";
import "./index.css";
import { determineTheme } from "./utils/themeUtils";
import { Theme } from "./_shared/constants";
import { Cookies } from "react-cookie";

declare global {
    interface Window {
        _env_: Record<string, string | boolean | number | undefined>;
    }
}

async function bootstrap() {
    try {
        //keep fallback url for auth redirection handling
      /*   const cookies = new Cookies();
        if (document.referrer) {
            const referrerUrl = new URL(document.referrer);
            const baseUrl = referrerUrl.origin;  
            cookies.set('fallbackurl', baseUrl, {
                path: '/',
                secure: true,
                sameSite: 'strict'
            });
            console.log("Fallback URL saved:", baseUrl);
        } */

        let config: Record<string, string | boolean | number> = {};
        try {
            const response = await fetch(`/env.json`);
            if (!response.ok) throw new Error("env.json non trovato");
            config = await response.json();
            console.log("env.json caricato");
        } catch (err) {
            console.warn("env.json non caricato");
        }

        const viteEnv = { ...import.meta.env };

        // Setta correttamente il proxy
        window._env_ = new Proxy({}, {
            get: (_, key: string) => {
                return config[key] ?? viteEnv[key];
            }
        });

        // Continua con il resto del bootstrap
        const theme = determineTheme(Theme.NOVA);
        if (theme === Theme.BPER) {
            await import("@orion/themes/biperTheme.css");
        } else {
            await import("@orion/themes/novaTheme.css");
        }

        const container = document.getElementById("root");
        if (!container) throw new Error("Elemento #root non trovato");
        createRoot(container).render(<App />);
    } catch (error) {
        console.error("Errore fatale nel bootstrap:", error);
    }
}

bootstrap();
